import AuditView from "./Audit/AuditView";

const Audit = ({ mode, id }) => {
  return <AuditView />;
};

export default Audit;
